// extracted by mini-css-extract-plugin
module.exports = {"container":"Style_container__2mbe_","paper":"Style_paper__3PMNj","title":"Style_title__1FkXy","detail":"Style_detail__1rTEX","copyright":"Style_copyright__3z1gH"};